var _a;
import { InsurancePlanStatusType } from 'generated/types';
import { enumValuesFactory } from 'utils/objectHelper';
var enumDescriptionMap = (_a = {},
    _a[InsurancePlanStatusType.Active] = 'Active',
    _a[InsurancePlanStatusType.Future] = 'Future',
    _a[InsurancePlanStatusType.Inactive] = 'Inactive',
    _a);
export var InsurancePlanStatusTypeEnum = {
    name: 'InsurancePlanStatusType',
    enumValues: enumValuesFactory(enumDescriptionMap)
};
